import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { createAdmin } from "../../redux/features/admin/adminSlice";
import { fetchRoles } from "../../redux/features/roles/rolesSlice";
import { fetchBrands } from "../../redux/features/brands/brandsSlice";

function AddNewAdmin({ onChange }) {
  const dispatch = useDispatch();
  const { createAdminLoading } = useSelector((state) => state.admin);
  const { roles } = useSelector((state) => state.roles);
  const { brands } = useSelector((state) => state.brands);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    role_id: "",
    brand_id: "",
  });
  const [errors, setErrors] = useState({});

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  useEffect(() => {
    dispatch(fetchRoles());
    dispatch(fetchBrands());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required.";
    if (!formData.role_id.trim()) newErrors.role_id = "Role is required.";
    // if (!formData.brand_id.trim()) newErrors.brand_id = "Brand is required.";
    if (!formData.email.trim()) newErrors.email = "Email is required.";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Invalid email format.";
    if (!formData.password.trim()) newErrors.password = "Password is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // returns true if no errors
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      toast.error("Please fill all required fields correctly.");
      return;
    }
    try {
      const payload = new FormData();
      payload.append("name", formData.name);
      payload.append("email", formData.email);
      payload.append("password", formData.password);
      payload.append("role_id", formData.role_id);
      payload.append("brand_id", formData.brand_id);

      await dispatch(createAdmin(payload)).unwrap();
      toast.success("Admin Created Successfully");
      setFormData({
        name: "",
        email: "",
        password: "",
        role_id: "",
        brand_id: "",
      });
      handleClose();
      onChange();
    } catch (error) {
      if (error?.errors) {
        const formattedErrors = {};

        Object.keys(error.errors).forEach((key) => {
          formattedErrors[key] = error.errors[key][0];
        });

        setErrors(formattedErrors);
      } else if (error?.message) {
        toast.error(error.message);
      } else {
        toast.error("Creation Failed");
      }
    }
  };

  return (
    <div className="flex justify-end mb-10">
      {/* Button to open modal */}
      <button
        onClick={handleOpen}
        className="bg-lightPurple hover:bg-purpleColor p-2 rounded-lg text-white"
      >
        <FontAwesomeIcon icon={faPlus} className="mr-1" />
        Add New Admin
      </button>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-lg w-[45%]  p-10 relative">
            <button
              onClick={handleClose}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>

            <h2 className="text-xl font-semibold border-b border-gray-200 mb-6 pb-5">
              Add New Admin
            </h2>

            <form onSubmit={handleSubmit} className="space-y-10">
              <div className="grid grid-cols-2 gap-5">
                <div>
                  <label className="block text-gray-700 font-medium mb-1">
                    Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter Name"
                    className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-purpleColor"
                  />
                  {errors.name && (
                    <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                  )}
                </div>

                <div>
                  <label className="block text-gray-700 font-medium mb-1">
                    Email <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter Email"
                    className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-purpleColor"
                  />
                  {errors.email && (
                    <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                  )}
                </div>
                <div>
                  <label className="block text-gray-700 font-medium mb-1">
                    Password <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Enter Password"
                    className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-purpleColor"
                  />
                  {errors.password && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.password}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-gray-700 font-medium mb-1">
                    Role <span className="text-red-500">*</span>
                  </label>
                  <select
                    name="role_id"
                    value={formData.role_id}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-purpleColor"
                  >
                    <option value="" hidden>
                      Select Role
                    </option>
                    {roles?.map((role) => (
                      <option key={role.id} value={role.id}>
                        {role.name}
                      </option>
                    ))}
                  </select>
                  {errors.role_id && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.role_id}
                    </p>
                  )}
                </div>
                <div>
                  <label className="block text-gray-700 font-medium mb-1">
                    Brand
                  </label>
                  <select
                    name="brand_id"
                    value={formData.brand_id}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-purpleColor"
                  >
                    <option value="" hidden>
                      Select Brand
                    </option>
                    {brands?.map((brand) => (
                      <option key={brand.id} value={brand.id}>
                        {brand.name}
                      </option>
                    ))}
                  </select>
                  {errors.brand_id && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.brand_id}
                    </p>
                  )}
                </div>
              </div>

              <div className="flex justify-end gap-3 mt-6">
                <button
                  type="button"
                  onClick={handleClose}
                  className="px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-100"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={createAdminLoading}
                  className={`px-4 py-2 rounded-md text-white ${
                    createAdminLoading
                      ? "bg-lightPurple/60 cursor-not-allowed"
                      : "bg-lightPurple hover:bg-purpleColor"
                  }`}
                >
                  {createAdminLoading ? "Saving..." : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default AddNewAdmin;
